import { createContext } from "react";
var defaultSearchState = {
    showSearch: false,
    setShowSearch: function () {
        // do nothing.
    },
    initialSearchTerm: "",
    setInitialSearchTerm: function () {
        // do nothing.
    },
};
export var SearchContext = createContext(defaultSearchState);
